var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.517a.65.65 0 0 1 .65.65v10.097l4.724-4.724a.65.65 0 0 1 .919.92l-5.833 5.833a.65.65 0 0 1-.92 0L3.707 10.46a.65.65 0 1 1 .92-.92l4.723 4.724V4.167a.65.65 0 0 1 .65-.65Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAzLjUxNjY3QzEwLjM1OSAzLjUxNjY3IDEwLjY1IDMuODA3NjggMTAuNjUgNC4xNjY2N0wxMC42NSAxNC4yNjQxTDE1LjM3MzcgOS41NDAzOEMxNS42Mjc2IDkuMjg2NTQgMTYuMDM5MSA5LjI4NjU0IDE2LjI5MyA5LjU0MDM4QzE2LjU0NjggOS43OTQyMiAxNi41NDY4IDEwLjIwNTggMTYuMjkzIDEwLjQ1OTZMMTAuNDU5NiAxNi4yOTNDMTAuMjA1OCAxNi41NDY4IDkuNzk0MjMgMTYuNTQ2OCA5LjU0MDM4IDE2LjI5M0wzLjcwNzA1IDEwLjQ1OTZDMy40NTMyMSAxMC4yMDU4IDMuNDUzMjEgOS43OTQyMiAzLjcwNzA1IDkuNTQwMzhDMy45NjA4OSA5LjI4NjU0IDQuMzcyNDUgOS4yODY1NCA0LjYyNjI5IDkuNTQwMzhMOS4zNSAxNC4yNjQxTDkuMzUgNC4xNjY2N0M5LjM1IDMuODA3NjggOS42NDEwMiAzLjUxNjY3IDEwIDMuNTE2NjdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";